const supportedFilesExtensions = [
    'jpg',
    'pdf',
    'png',
];

export default supportedFilesExtensions;
